<template>
  <div class="dashboard-card">
    <template v-if="$parent.currentPort.brand !== 'OXBY'">
      <div class="card-header">
        <awesomeIcon icon="cog"/> Gegevens wijzigen
      </div>
      <div class="card-content" @click="$parent.redo()">
        <awesomeIcon icon="address-card" style="height: 50px; width: 50px;"/>
        <h3>
          Is uw situatie veranderd, andere tegenrekening of bent u verhuisd?
        </h3>
        <p class="grey">
          Klik <u>hier</u> om uw wijzigingen door te geven.
        </p>
      </div>
      <div style="display: flex; flex-direction: column-reverse;">
        <div class="form-notice" v-if="tooltipText">
          {{ tooltipText }}
        </div>
        <label for="contactuploadfile" class="file-label button">
          <awesomeIcon icon="upload"/> Veilig Bestanden uploaden
        </label>
        <input
          v-show="false" ref="files" id="contactuploadfile"
          type="file" multiple @change="uploadFilesChanged"
        >
      </div>
    </template>
    <oxbyOverstapDBWidget v-else />
  </div>
</template>

<script>
import oxbyOverstapDBWidget from './oxbyOverstapDB';

export default {
  components: {
    oxbyOverstapDBWidget,
  },
  name: 'goalChangerWidget',
  data() {
    return {
      tooltipText: '',
    };
  },
  methods: {
    uploadFilesChanged(e) {
      this.uploadFiles(e.target.files.length);
    },
    uploadFiles() {
      this.sdk.addFile(
        this.$refs.files.files,
        (response) => {
          if (response.status === 200) {
            // success
            this.tooltipText = 'We hebben uw bestanden ontvangen.';
          } else {
            this.tooltipText = 'Fout met uploaden. Wij accepteren alleen afbeeldingen en pdf bestanden.';
          }
        },
        this.$store.state.currentPort,
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.card-content {
  color: $color-background;
  text-align: center;
  padding: 0 20px !important;
  cursor:pointer;
  .grey {
    cursor: pointer;
  }
}
.file-label {
  height: initial;
  border: 1px solid $color-background;
}
</style>
